import React from 'react';

interface IConditionalWrapper {
  children: React.ReactNode;
  condition: boolean;
  wrapper: (children: React.ReactNode) => React.ReactNode | null;
}

export const ConditionalWrapper = ({ children, condition, wrapper }: IConditionalWrapper) => {
  return <>{condition ? wrapper(children) : children}</>;
};
